<h1 style="text-align: center;">Hello</h1>
<h1>{{item|json}}</h1>
<!-- <h1>{{newitem|json}}</h1> -->
<button (click)="navi()">navigate</button>